import { createContext, useContext } from 'react';
import type { CalendarGranularity, GranularityToggleOption, PresetOption } from '../types';
import type { OnValidateCallbackType } from '../validation';
import type { DateValue } from '../types';

export interface DateRangePickerContextValue {
  value: DateValue;
  onChange: (value: DateValue) => void;
  onClose: () => void;

  granularity: CalendarGranularity;
  onGranularityChange?: (g: CalendarGranularity) => void;
  allowedGranularities?: GranularityToggleOption[];

  presetOptions: PresetOption[];
  showPresets: boolean;

  caption: string;
  disabled: boolean;
  emptyMessage: string;
  hideDateInputs: boolean;
  hideButtons: boolean;

  disabledDates: (date: Date) => boolean;
  onValidate?: OnValidateCallbackType;
  minDate?: Date;
  maxDate?: Date;
  fixedNumberOfMonth?: number;

  isComparison: boolean;
  mainRangeDuration?: number;
}

const DateRangePickerContext = createContext<DateRangePickerContextValue | null>(null);

export function useDateRangePickerContext(): DateRangePickerContextValue {
  const ctx = useContext(DateRangePickerContext);
  if (!ctx) {
    throw new Error('useDateRangePickerContext must be used inside <DateRangePicker>');
  }
  return ctx;
}

export { DateRangePickerContext };
